import React from 'react';
import { FcVoicePresentation } from 'react-icons/fc';
import styled from 'styled-components';
import { DarkThemeColor ,ThemeBorderColor} from '../../utils';
import Card from './Card';

function MessagePointCard(props) {
    return (
        <Card clickCardHandler={props.clickCardHandler} title="پیام های دریافتی" icon={FcVoicePresentation}>
            <Score>{props.SumMessageCount}</Score>
        </Card>
    );
}
const Score = styled.span`
    color: ${DarkThemeColor};
    width: 35px;
    height: 35px;
    margin:10px;
    display: inline-block;
    border-radius: 50%;
    padding: 0.7rem;
    border: 2px solid ${ThemeBorderColor};
    font-size: x-large;
`;
export default MessagePointCard;